/* eslint-disable no-unused-vars */
/* eslint-disable strict */
"use strict";

import _ from "lodash";

const Utils = {
  generateTimeIntervals: (
    startTime,
    endTime,
    intervalInMinutes,
    data,
    mergeOn
  ) => {
    const startHour = startTime * 60;
    const endHour = endTime * 60;
    const timeIntervals = [];

    for (var i = startHour; i < endHour; i = i + intervalInMinutes) {
      const time = returnTime(i);
      const inserter = data.find((datum) => datum.time === time);

      timeIntervals[time] = inserter
        ? { ...inserter }
        : { time: time, volume: 0 };
    }

    return timeIntervals;
  },
  generateBarchatData: (
    startTime,
    endTime,
    intervalInMinutes,
    data,
    mergeOn
  ) => {
    const startHour = startTime * 60;
    const endHour = endTime * 60;
    const timeIntervals = [];
    for (var i = startHour; i < endHour; i = i + intervalInMinutes) {
      const time = returnTime(i);
      const timeForward = returnTime(i + intervalInMinutes);
      var volume = 0;
      for (var j = 0; j < data.length; j++) {
        if (
          data[j].time.localeCompare(time) > 0 &&
          data[j].time.localeCompare(timeForward) <= 0
        ) {
          volume += data[j].volume;
        }
        if (data[j].time.localeCompare(timeForward) > 0) break;
      }
      timeIntervals[time] = { time: time, volume: volume };
    }

    return timeIntervals;
  },
  generateTimeIntervalsUntil: (
    startTime,
    endTime,
    intervalInMinutes,
    data,
    mergeOn
  ) => {
    const startHour = startTime * 60;
    const endHour = endTime * 60;
    const timeIntervals = [];

    for (var i = startHour; i <= endHour; i = i + intervalInMinutes) {
      const time = returnTime(i);
      const inserter = data.find((datum) => datum.time === time);

      timeIntervals[time] = inserter
        ? { ...inserter }
        : { time: time, volume: 0 };
    }

    return timeIntervals;
  },
  mergeData: (data, data2, field1, field2) => {
    return data.map((itm) => ({
      ...data2.find((item) => item[field1] === itm[field2] && item),
      ...itm,
    }));
  },
};

function returnTime(timeTotal) {
  const hour = Math.floor(timeTotal / 60, 0);
  const minutes = timeTotal - hour * 60;
  const reply = fillZeros(hour) + ":" + fillZeros(minutes);
  return reply;
}

function fillZeros(number) {
  return number < 10 ? "0" + number : number;
}

export default Utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js